import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Lightning, EnvelopeSimple, Lock, SpinnerGap } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : (location.state?.from || "/account"));
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <>
      <SEO title="Sign In" description="Sign in to your Ebikes&Gear account." path="/login" />
      <div className="container-px grid min-h-[80vh] place-items-center py-12">
        <div className="w-full max-w-md rounded-[2rem] border border-border bg-card p-8 shadow-soft" data-testid="login-card">
          <span className="grid h-12 w-12 place-items-center rounded-2xl bg-primary text-primary-foreground"><Lightning size={26} weight="fill" /></span>
          <h1 className="mt-5 text-3xl font-black tracking-tight">Welcome back</h1>
          <p className="mt-1 text-muted-foreground">Sign in to manage orders, wishlist and more.</p>

          {error && <div className="mt-5 rounded-xl bg-primary/10 px-4 py-3 text-sm text-primary" data-testid="login-error">{error}</div>}

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="flex items-center gap-3 rounded-xl border border-border bg-background px-4 py-3">
              <EnvelopeSimple size={20} className="text-muted-foreground" />
              <input required type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className="flex-1 bg-transparent text-sm outline-none" data-testid="login-email" />
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-border bg-background px-4 py-3">
              <Lock size={20} className="text-muted-foreground" />
              <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="flex-1 bg-transparent text-sm outline-none" data-testid="login-password" />
            </div>
            <button disabled={busy} className="btn-primary w-full" data-testid="login-submit">
              {busy ? <SpinnerGap size={20} className="animate-spin" /> : "Sign In"}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-muted-foreground">
            New here? <Link to="/register" className="font-semibold text-primary hover:underline">Create an account</Link>
          </p>
        </div>
      </div>
    </>
  );
}
